

































































import discountTypes from '@/store/types/discount';
// Componentes
import BasicInfo from '@/components/Discount/DiscountBasicInfo.vue';
import Participation from '@/components/Discount/DiscountParticipation.vue';
import Rules from '@/components/Discount/DiscountRules.vue';
import Amount from '@/components/Discount/DiscountAmount.vue';
import Recurrence from '@/components/Discount/DiscountRecurrence.vue';
import Cap from '@/components/Discount/DiscountCap.vue';
import copyObj from '@/util/copyObj';
import { DiscountParams } from '@/store/interfaces/discount';
import { rules } from '@/components/Discount/rules';
import { AxiosResponse } from 'axios';
import { TeipNotifications } from '@/util/teipNotifications';
import { IObjectKeys } from '@/store/interfaces/generic';
import { navLink } from '@/ts/navegationLinks';
import { tRule } from '@/components/Discount/types/rules';
import { mapActions } from 'vuex';
import Vue from 'vue';

const currency = 'USD';

export default Vue.extend({
  name: 'NewDiscount',
  components: {
    BasicInfo,
    Participation,
    Rules,
    Amount,
    Cap,
    Recurrence,
  },
  data: () => ({
    clean: true,
    loading: true,
    model: {
      amount_cents: 0,
      discount_type: 'regular',
      amount_currency: currency,
      bonus: 'percentage',
      budget_cents: 0,
      budget_currency: currency,
      cap: 'all',
      commerce_participation_percentage: 0,
      description: '',
      end_at: '',
      kind: 'individual',
      name: '',
      network: 'all',
      participation: 'platform',
      percentage: 0,
      platform_participation_percentage: 0,
      start_at: '',
      transactions_count: 0,
      occurrences_count: 0,
      user_occurrences_count: 0,
      minimum_amount_cents: 0,
      minimum_amount_currency: currency,
      maximum_amount_cents: 0,
      maximum_amount_currency: currency,
      transaction_amount_cents: 0,
      transaction_amount_currency: currency,
      ceiling_amount_cents: 0,
      ceiling_amount_currency: currency,
      range_minimum_amount_cents: 0,
      range_minimum_amount_currency: currency,
      range_maximum_amount_cents: 0,
      range_maximum_amount_currency: currency,
      average_amount_cents: 0,
      average_amount_currency: currency,
      rules: [
        {
          rule: 'all',
          data: {},
          meta: [],
        }
      ],
    } as DiscountParams,
    savingDiscount: false,
    navlink: [] as navLink[],
  }),
  async mounted() {
    this.filledNavLinks();
    const discount_id = this.$route.params.discount_id;
    if (discount_id) {
      await this.gettingDiscountInfo(discount_id);
    }
    this.loading = false;
  },
  methods: {
    ...mapActions({
      saveDiscount: `discount/${discountTypes.actions.SAVE_DISCOUNT}`,
      updateDiscount: `discount/${discountTypes.actions.EDIT_DISCOUNT}`,
      singledDiscount: `discount/${discountTypes.actions.DISCOUNT}`,
    }),
    async gettingDiscountInfo(discount_id: string) {
      await this.singledDiscount(discount_id).then((res: AxiosResponse) => {
        const response = res.data.data;
        Object.keys(response).forEach((k: string) => {
          if (k.includes('_cents')) {
            response[k] = response[k] / 100;
          }
        });
        this.model = response;
      });
    },
    filledNavLinks() {
      this.navlink = [
        {
          name: 'Descuentos',
          active: false,
          to: '/noveltiesAndPromotions/discounts',
        },
        {
          name: this.topLabel(),
          active: true,
        }
      ];
    },
    saveNewDiscount(): void {
      this.savingDiscount = true;
      const cloneModel: IObjectKeys = copyObj(this.model);
      const relationShips: tRule[] = copyObj(rules);
      relationShips.shift();

      const notification = new TeipNotifications();

      if (cloneModel.rules.length > 0 && cloneModel.rules[0].rule === 'all') {
        cloneModel.rules = [];
      }
      Object.entries(cloneModel).forEach(([key, value]) => {
        if (key.includes('_cents')) {
          cloneModel[key] = value * 100;
        }
      });
      if (cloneModel.kind === 'collective') {
        const rulesAllowed = ['commerces', 'branches', 'commerce_kinds'];
        cloneModel.rules = cloneModel.rules.filter((rules: { rule: string }) => {
          return rulesAllowed.includes(rules.rule);
        });
      }

      const discount_id = this.$route.params.discount_id;
      if (discount_id) {
        if (cloneModel.bonus === 'percentage') {
          cloneModel.amount_cents = 0;
        }

        if (cloneModel.bonus === 'fixed') {
          cloneModel.percentage = 0;
        }

        if (cloneModel.participation !== 'shared') {
          cloneModel.platform_participation_percentage = 0;
          cloneModel.commerce_participation_percentage = 0;
        }

        if (cloneModel.cap === 'all') {
          cloneModel.ceiling_amount_cents = 0;
        }

        this.updateDiscount(cloneModel)
          .then(() => {
            notification.success('Descuento actualizado correctamente');
            this.goToList();
          })
          .catch(() => {
            notification.warning('Algo ha salido mal :(');
          })
          .finally(() => {
            this.savingDiscount = false;
          });
      } else {
        this.saveDiscount(cloneModel)
          .then(() => {
            notification.success('Descuento guardado correctamente');
            this.goToList();
          })
          .catch(() => {
            notification.warning('Algo ha salido mal :(');
          })
          .finally(() => {
            this.savingDiscount = false;
          });
      }
    },

    goToList(): void {
      this.$router.push({
        name: 'NoveltiesDiscountList',
      });
    },

    cancel(): void {
      this.goToList();
    },
    buttonLabel(): string {
      return this.$route.params.discount_id
        ? 'Actualizar Descuento'
        : 'Guardar Descuento';
    },

    topLabel(): string {
      return this.$route.params.discount_id
        ? 'Editar Descuento'
        : 'Nuevo Descuento';
    },
  },
});
